import styled from 'styled-components';

import { btn, btnLink, primary } from '../base';

interface buttonColor {
  buttonColor?: string;
  buttonFont?: string;
}

export const PrimayButtonC = styled.button`
  ${btn(primary)}
`;

export const PrimayButtonLinkC = styled.div`
  ${btnLink(primary)}
`;

export const text = styled.span<buttonColor>`
  font-style: normal;
  color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'var(--text-invert)')};
  font-size: ${({ buttonFont }) => (buttonFont ? buttonFont : 'var(--fs-body)')};
`;
